import React, { useEffect, useState } from "react";
import * as API from "../helpers/api";
import config from "../config";
import Loading from "react-loader-spinner";
import { useLang } from "../helpers/language";
import parse from "html-react-parser";

import AboutBlock from "../components/about-block/AboutBlock";

import "../assets/css/pages/partnership.scss";

const Partnership = ({ dictionary }) => {
  const { lang } = useLang();
  const [isBusy, setBusy] = useState(true);
  const [partnership, setPartnership] = useState(true);
  const [partners, setPartners] = useState(true);
  useEffect(() =>
  {
    window.scrollTo(0, 0);
    (async () => {
      let rawPartnership = await API.get(config.api.partnership);
      setPartnership(rawPartnership);

      let rawPartners = await API.get(config.api.partner,{},{},true);
      setPartners(rawPartners);
      setBusy(false);
    })();
  }, [isBusy]);
  if (!isBusy && partnership.length > 0 && partners.length > 0)
  return (
    <div id="partnership">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8">
            <h1>{partnership[0]?.title[lang] ? partnership[0].title[lang] : ''}</h1>
                {partnership[0]?.desc[lang] ? parse(partnership[0].desc[lang]) : ''}
          </div>
        </div>
        <div className="row" style={{ marginTop: 8, paddingBottom: 7 }}>
          {partners.map((partner,index) => (
            <div
              className="col-md-4"
              key={`partner-${index}`}
              style={{ marginTop: 36 }}
            >
              <div className="partner">
                <img
                  src={partner.uploads ?`${config.api.API_URL}/${partner.uploads[0]?.path}` : ''}
                  width="100%"
                  alt=""
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      <AboutBlock
              title={config.aboutUsBlock.contactUs.title[lang]}
              subTitle={''}
              content={''}
              buttonText={config.aboutUsBlock.contactUs.button[lang]}
              as={
                `/contact-us?lang=${lang}&contact=other`
            }
              href={
                `/contact-us?lang=${lang}&contact=other`
            }
          />
    </div>
  );
  else return <Loading type="Oval" color="#FFBE03" className="dms-loader" />
};

export default Partnership;
